<template>
  <div class="verification scrollable -y">

    <div class="page-wrapper">

      <prompt-touch-to-proceed
      v-if="!agreeToBeginVerification"
      v-on:onTouchScreen="beginVerification"></prompt-touch-to-proceed>

      <verification-page
      v-else></verification-page>

    </div>

  </div>
</template>

<script>
import PromptTouchToProceed from '@/pages/Verification/PromptTouchToProceed'
import VerificationPage from '@/pages/Verification/VerificationPage'
export default {
  name: 'verification',
  components: {
    PromptTouchToProceed,
    VerificationPage
  },
  computed: {
  },
  data: function () {
    return {
      agreeToBeginVerification: false
    }
  },
  watch: {
    agreeToBeginVerification: function () {
      if (this.agreeToBeginVerification) {
        this.startVerificationProcess()
      }
    }
  },
  created: function () {
  },
  methods: {
    beginVerification: function () {
      this.agreeToBeginVerification = true
    },
    startVerificationProcess: function () {
      this.$logger.info('startVerificationProcess')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.verification {
  /* common */
  background-color: #000;
  /* size */
  width: 100%;
  height: 100%;
  /* position */
  position: relative;
  /* alignment */
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  overflow: hidden;
}

.verification .page-wrapper {
  /* common */
  background-color: #000;
  color: #fff;
  /* size */
  display: flex;
  justify-content: center;
  /* max-width: 400px;
  max-height: 700px; */
  min-height: 400px;
  width: 100%;
  height: 100%;
  min-width: 100%;
  min-height: 100%;
  max-height: 100%;
  /* position */
  position: relative;
  /* style */
  box-shadow: 0 0 4px 0 hsla(0, 0%, 0%, 0.5);
}

</style>



// WEBPACK FOOTER //
// src/pages/Verification.vue